import log from 'loglevel';
/**
 * dom 布局工具类
 *
 * @export
 * @class Layout
 * @author zhenliang.sun
 */
export default class Layout {
  constructor() {
    this.calcType = 'landscape'; // Landscape/Portrait
    this.originWidth = 0;
    this.originHeight = 0;
  }

  initContainer(elId, w, h) {
    let el = document.getElementById(elId);
    el.style.position = 'absolute';
    el.style.width = `${w}px`;
    el.style.height = `${h}px`;
    // 父容器添加这个属性， iframe 添加 width=1px min-width:100% ,解决旋转问题
    el.style.overflow = 'auto';
    return el;
  }

  resizeContainer(elId, w, h) {
    let el = document.getElementById(elId);
    el.style.width = `${w}px`;
    el.style.height = `${h}px`;
    return el;
  }

  /**
   * 课件大小缩放
   * @param {Element} node 课件dom元素（img或iframe）
   * @param {Number} w 课件的宽
   * @param {Number} h 课件的高
   * @param {Number} cw 容器的宽
   * @param {Number} ch 容器的高
   */
  layout(node, w, h, cw, ch) {
    // 分别计算容器宽相对课件宽比例,容器高相对课件高比例；保留7位小数防止产生黑边
    const wRatio = parseFloat((cw / w).toFixed(7));
    const hRatio = parseFloat((ch / h).toFixed(7));
    // 哪个比例小取哪个值
    const scale = wRatio < hRatio ? wRatio : hRatio;
    node.style.width = `${w}px`;
    node.style.height = `${h}px`;
    node.style.top = '50%';
    node.style.left = '50%';
    node.style.transform = `scale(${scale}) translate3d(-50%,-50%,0)`;
    node.style.transformOrigin = 'left top';

    let cvsContainer = document.getElementsByClassName('canvas-container')[0];
    if (cvsContainer) {
      cvsContainer.style.position = 'absolute';
      cvsContainer.style.top = '0';
    }
  }

  scale(node, scaleFactor, xPos, yPos) {
    log.info(`布局设置缩放${node}, ${scaleFactor}, ${xPos}, ${yPos}`);
  }
}
